import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';

class SnapchatOptions extends React.Component {
    render() {
        let currentPanel = null,
            constants = this.props.app.config.constants,
            inputSourceChooser = null;

        if (this.props.activePanel !== 'advanced') {
            if (this.props.fieldMapping.match("output") &&
                this.props.hasInputOverrides &&
                this.props.socialOverrides !== undefined &&
                this.props.socialOverrides &&
                this.props.socialOverrides.postStyle !== undefined &&
                this.props.socialOverrides.postStyle !== constants.SOC_OVRD_STYLE_LINK) {
                inputSourceChooser = this.props.getInputSourceFields();
            } else if (!this.props.fieldMapping.match("output")) {
                inputSourceChooser = this.props.getInputSourceFields();
            }

            currentPanel = (
                <div>
                    {inputSourceChooser}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(SnapchatOptions);
